module.exports = __webpack_public_path__ + "img/logo_ali2.32b84246.png";